<template>
    <vx-expandable-card>
        <template v-slot:content>
            <h3 class="text-xl text-slate-700 font-extrabold">{{ file ? 'Upload Preview' : 'Upload' }}</h3>
            <p class="text-sm" data-test="upload-summary-text">
                <template v-if="file">
                    Last chance to confirm everything looks good before we run the import.
                </template>
                <template v-else>
                    <slot></slot>
                </template>
            </p>

            <drag-and-drop-file
                v-model="file"
                :icon="faFileCsv"
                :validate="props.validator.validate"
                @selected="emit('selected', $event)"
                class="my-4"
            ></drag-and-drop-file>

            <vx-alert v-if="!file" color="info" :closeable="false">
                Files must be <strong>CSV</strong> and less than <strong>{{ formatFileSize(props.validator.maxFileSizeBytes) }}</strong>.
            </vx-alert>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { faFileCsv } from '@fortawesome/pro-solid-svg-icons';
import { VxAlert, VxExpandableCard } from '@voxie/frontend-components';
import DragAndDropFile from '~/components/general/DragAndDropFile.vue';
import { ref } from 'vue';
import { formatFileSize, type CsvValidator } from '~/components/general/createCsvValidator';

const props = defineProps<{
    validator: CsvValidator;
}>();

const emit = defineEmits<{
    selected: [file: File];
}>();

const file = ref<File | null>(null);
</script>
